// import React, { useEffect, useState } from "react";
// import { Box } from "@mui/material";
// import { AnimatePresence } from "framer-motion";
// import FloatingActions from "./components/layout/FloatingActions";
// import Footer from "./components/layout/Footer";
// import LoadingScreen from "./components/layout/LoadingScreen";
// import Navbar from "./components/layout/Navbar";
// import AboutSection from "./components/sections/AboutSection";
// import AcademicsSection from "./components/sections/AcademicsSection";
// import AchievementsSection from "./components/sections/AchievementsSection";
// import AdmissionsBanner from "./components/sections/AdmissionsBanner";
// import ContactSection from "./components/sections/ContactSection";
// import FacilitiesSection from "./components/sections/FacilitiesSection";
// import FacultySection from "./components/sections/FacultySection";
// import GallerySection from "./components/sections/GallerySection";
// import HeroSection from "./components/sections/HeroSection";
// import ShowcaseSection from "./components/sections/ShowcaseSection";
// import TestimonialsSection from "./components/sections/TestimonialsSection";
// import TimelineSection from "./components/sections/TimelineSection";
// import TransportSafetySection from "./components/sections/TransportSafetySection";
// import VisionMissionSection from "./components/sections/VisionMissionSection";
// import WhyChooseSection from "./components/sections/WhyChooseSection";
// import {
//   aboutPoints, academicCards, achievements, chooseCards,
//   contactQuickFacts, facilityCards, facultyHighlights, galleryImages,
//   heroHighlights, heroSlides, missionCards, navItems, safetyCards,
//   schoolInfo, showcaseSlides, sportsCards, stats, testimonials, timelineEvents,
// } from "./data/siteContent";

// const sectionIds = ["hero", "about", "academics", "facilities", "gallery", "admissions", "contact"];

// const App = () => {
//   const [activeSection, setActiveSection] = useState("hero");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 1400);
//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         const visible = entries
//           .filter((e) => e.isIntersecting)
//           .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
//         if (visible?.target?.id) setActiveSection(visible.target.id);
//       },
//       { threshold: [0.3, 0.5, 0.7], rootMargin: "-20% 0px -20% 0px" }
//     );
//     sectionIds.forEach((id) => {
//       const el = document.getElementById(id);
//       if (el) observer.observe(el);
//     });
//     return () => observer.disconnect();
//   }, []);

//   const handleNavigate = (id) => {
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   return (
//     <Box sx={{ position: "relative", minHeight: "100vh" }}>
//       <AnimatePresence>{loading && <LoadingScreen />}</AnimatePresence>

//       <Navbar navItems={navItems} onNavigate={handleNavigate} activeSection={activeSection} />

//       <Box component="main">
//         <HeroSection slides={heroSlides} highlights={heroHighlights} schoolInfo={schoolInfo} onNavigate={handleNavigate} />
//         <AboutSection schoolInfo={schoolInfo} points={aboutPoints} />
//         <WhyChooseSection cards={chooseCards} />
//         <AcademicsSection cards={academicCards} />
//         <FacilitiesSection facilities={facilityCards} sports={sportsCards} />
//         <ShowcaseSection slides={showcaseSlides} onNavigate={handleNavigate} />
//         <AchievementsSection stats={stats} achievements={achievements} />
//         <GallerySection images={galleryImages} />
//         <AdmissionsBanner phone={schoolInfo.phone} onNavigate={handleNavigate} />
//         <TestimonialsSection testimonials={testimonials} />
//         <FacultySection highlights={facultyHighlights} />
//         <TimelineSection events={timelineEvents} />
//         <VisionMissionSection cards={missionCards} />
//         <TransportSafetySection cards={safetyCards} schoolInfo={schoolInfo} />
//         <ContactSection schoolInfo={schoolInfo} quickFacts={contactQuickFacts} />
//       </Box>

//       <Footer schoolInfo={schoolInfo} navItems={navItems} onNavigate={handleNavigate} />
//       <FloatingActions phone={schoolInfo.phone} email={schoolInfo.email} />
//     </Box>
//   );
// };

// export default App;







import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import FloatingActions from "./components/layout/FloatingActions";
import Footer from "./components/layout/Footer";
import LoadingScreen from "./components/layout/LoadingScreen";
import Navbar from "./components/layout/Navbar";
import EnquiryPopup from "./components/layout/EnquiryPopup"; // Import popup
import AboutSection from "./components/sections/AboutSection";
import AcademicsSection from "./components/sections/AcademicsSection";
import AchievementsSection from "./components/sections/AchievementsSection";
import AdmissionsBanner from "./components/sections/AdmissionsBanner";
import ContactSection from "./components/sections/ContactSection";
import FacilitiesSection from "./components/sections/FacilitiesSection";
import FacultySection from "./components/sections/FacultySection";
import GallerySection from "./components/sections/GallerySection";
import HeroSection from "./components/sections/HeroSection";
import ShowcaseSection from "./components/sections/ShowcaseSection";
import TestimonialsSection from "./components/sections/TestimonialsSection";
import TimelineSection from "./components/sections/TimelineSection";
import TransportSafetySection from "./components/sections/TransportSafetySection";
import VisionMissionSection from "./components/sections/VisionMissionSection";
import WhyChooseSection from "./components/sections/WhyChooseSection";
import {
  aboutPoints, academicCards, achievements, chooseCards,
  contactQuickFacts, facilityCards, facultyHighlights, galleryImages,
  heroHighlights, heroSlides, missionCards, navItems, safetyCards,
  schoolInfo, showcaseSlides, sportsCards, stats, testimonials, timelineEvents,
} from "./data/siteContent";

const sectionIds = ["hero", "about", "academics", "facilities", "gallery", "admissions", "contact"];

const App = () => {
  const [activeSection, setActiveSection] = useState("hero");
  const [loading, setLoading] = useState(true);
  const [showEnquiryPopup, setShowEnquiryPopup] = useState(false);

  // Initial loading
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1400);
    return () => clearTimeout(timer);
  }, []);

  // Auto-popup after 5 seconds of page load
  useEffect(() => {
    let popupTimer;
    if (!loading) {
      popupTimer = setTimeout(() => {
        setShowEnquiryPopup(true);
      }, 5000);
    }
    return () => clearTimeout(popupTimer);
  }, [loading]);

  // Intersection Observer for active section
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible?.target?.id) setActiveSection(visible.target.id);
      },
      { threshold: [0.3, 0.5, 0.7], rootMargin: "-20% 0px -20% 0px" }
    );
    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const handleNavigate = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <Box sx={{ position: "relative", minHeight: "100vh" }}>
      <AnimatePresence>{loading && <LoadingScreen />}</AnimatePresence>

      <Navbar navItems={navItems} onNavigate={handleNavigate} activeSection={activeSection} />

      <Box component="main">
        <HeroSection slides={heroSlides} highlights={heroHighlights} schoolInfo={schoolInfo} onNavigate={handleNavigate} />
        <AboutSection schoolInfo={schoolInfo} points={aboutPoints} />
        <WhyChooseSection cards={chooseCards} />
        <AcademicsSection cards={academicCards} />
        <FacilitiesSection facilities={facilityCards} sports={sportsCards} />
        <ShowcaseSection slides={showcaseSlides} onNavigate={handleNavigate} />
        <AchievementsSection stats={stats} achievements={achievements} />
        <GallerySection images={galleryImages} />
        <AdmissionsBanner phone={schoolInfo.phone} onNavigate={handleNavigate} />
        <TestimonialsSection testimonials={testimonials} />
        <FacultySection highlights={facultyHighlights} />
        <TimelineSection events={timelineEvents} />
        <VisionMissionSection cards={missionCards} />
        <TransportSafetySection cards={safetyCards} schoolInfo={schoolInfo} />
        <ContactSection schoolInfo={schoolInfo} quickFacts={contactQuickFacts} />
      </Box>

      <Footer schoolInfo={schoolInfo} navItems={navItems} onNavigate={handleNavigate} />
      <FloatingActions phone={schoolInfo.phone} email={schoolInfo.email} />

      {/* Enquiry Popup - Appears 5 seconds after page loads */}
      <EnquiryPopup
        open={showEnquiryPopup}
        onClose={() => setShowEnquiryPopup(false)}
      />
    </Box>
  );
};

export default App;